import type { GridField } from "@/types/template";

interface Props {
  field: GridField;
  value: Record<string, Record<string, string>>;
  onChange: (value: unknown) => void;
}

export function GridInput({ field, onChange, value }: Readonly<Props>) {
  const getCellValue = (rowLabel: string, col: string): string => {
    const row = field.rows.find((r) => r.label === rowLabel);
    return value[rowLabel]?.[col] ?? row?.defaults?.[col] ?? "";
  };

  const setCellValue = (rowLabel: string, col: string, cellValue: string) => {
    const rowData = { ...value[rowLabel], [col]: cellValue };
    onChange({ ...value, [rowLabel]: rowData });
  };

  return (
    <table className="grid-table">
      <thead>
        <tr>
          <th></th>
          {field.columns.map((col) => (
            <th key={col}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {field.rows.map((row) => (
          <tr key={row.label}>
            <td>
              <strong>{row.label}</strong>
            </td>
            {field.columns.map((col) => (
              <td key={col}>
                <input
                  type="text"
                  value={getCellValue(row.label, col)}
                  onChange={(e) => {
                    setCellValue(row.label, col, e.target.value);
                  }}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
